import React, { useRef, useEffect } from 'react';
import Col from 'react-bootstrap/Col';
import Row from 'react-bootstrap/Row';
import { useDispatch, useSelector } from 'react-redux';
import BlogPosts from '../../components/BlogPosts';
import AssetClassHeader from '../../components/AssetClassHeader';
import { setFilteredPosts } from '../../redux/slices';

const TTCContainer = React.memo(() => {
  const dispatch = useDispatch();
  const stories = useSelector((state) => state.app.stories);
  const groupWrapper = useRef(null);

  useEffect(() => {
    dispatch(setFilteredPosts(stories));
  }, [stories]);
  const hasDefaultFilter = window.ttCentre.assetClass || '';
  return (
    <>
      {!hasDefaultFilter && (
        <header>
          <Row className="justify-content-end px-3 content">
            <Col xs={6} className="col-md-auto  p-3">
              <AssetClassHeader />
            </Col>
          </Row>
        </header>
      )}
      <main ref={groupWrapper} className="content">
        <section className="">
          <BlogPosts />
        </section>
      </main>
    </>
  );
});
TTCContainer.displayName = 'TTCContainer';
export default TTCContainer;
